import React, { Component } from 'react'
import styled from 'styled-components'

import Module from 'ui/components/Module'
import Header from 'ui/components/modules/Header'
import PageHeader from 'ui/components/modules/PageHeader'
import BodyText from 'ui/components/modules/BodyText'
import Quote from 'ui/components/modules/Quote'
import Gallery from 'ui/components/modules/Gallery'
import ImageAndText from 'ui/components/modules/ImageAndText'
import Distance from 'ui/components/modules/Distance'
import TourDates from 'ui/components/modules/TourDates'
import ConcertTeaser from 'ui/components/modules/ConcertTeaser'
import ReleaseTeaser from 'ui/components/modules/ReleaseTeaser'
import PoelseHjul from 'ui/components/modules/PoelseHjul'

const Wrapper = styled.div``

const Missing = styled.div`
  padding: 30px;
  background-color: ${props => props.theme.colors.tones.light};
  color: ${props => props.theme.colors.tones.dark};
  font-size: 18px;
`

export default class Modules extends Component {
  getModules() {
    const { modules, post } = this.props
    return modules.map((module, index) => {
      const key = index + '-' + module.layout
      switch (module.layout) {
        case 'header':
          return <Header {...module} post={post} />
        case 'pageHeader':
          return <PageHeader {...module} post={post} />
        case 'bodyText':
          return <BodyText {...module} />
        case 'quote':
          return <Quote {...module} />
        case 'gallery':
          return <Gallery {...module} />
        case 'imageAndText':
          return <ImageAndText {...module} />
        case 'distance':
          return <Distance {...module} />
        case 'tourDates':
          return <TourDates {...module} />
        case 'concertTeaser':
          return <ConcertTeaser {...module} />
        case 'releaseTeaser':
          return <ReleaseTeaser {...module} />
        case 'poelsehjulet':
          return <PoelseHjul {...module} />
        default:
          return (
            <Missing key={key}>
              Missing implementation of {module.layout}
            </Missing>
          )
      }
    })
  }

  render() {
    return (
      <Wrapper>
        {this.getModules().map((module, index) => (
          <Module key={index}>{module}</Module>
        ))}
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Modules.js